/**
 * Column Alignment.
 * @hidden
 */
export enum Alignment {
    Default = 1,
    Left = 2,
    Middle = 3,
    Right = 4
}